{
  "parties": "Parties",
  "create-assoc": "Create Association",
  "create": "Create",
  "contact": "Contact",
  "kind": "Kind",
  "add-party": "Add party",
  "first-name": "First name",
  "last-name": "Last name",
  "email": "Email",
  "cancel": "Cancel",
  "role": "Role",
  "owner": "Owner",
  "gender": "GENDER",
  "ssn": "SSN",
  "addresses": "Addresses",
  "spouse": "Spouse",
  "buyers": "Buyers",
  "on": "on",
  "title": "Title",
  "POA": "POA",
  "order-id": "Order ID",
  "not-selected": "Select a party",
  "not-selected-label": "Choose a party to see their roles, reporting details and associations.",
  "search-through": "Search through all existing contacts to add to the order",
  "search-through-text": "Search through all existing contacts to add to the order or you can add a new one from Contacts.",
  "type-as-3-characters": "Type at least 3 characters to start searching",
  "clear-filter": "Show common parties",
  "show-known-parties": "Suggested",
  "on-this-order": "On this order",
  "assigned-to": "Assigned to {{partyName}} as {{linkedAs}}",
  "assigned-as": "Assigned {{partyName}} as {{linkedAs}}",
  "roleLabel": "Role: {{role}}",
  "contactFoundInDocument": "Contact found in the document: {{contact}}",
  "deletedRole": "You have deleted the {{role}}",
  "contactSearchMessage": "We found {{count}} matches in contacts, select one of those in the field or looking for any contact in the system writing there or you can create a new contact in the button below",
  "contactSearchMessageNoMatches": "Looking for any contact in the system writing there or you can create a new contact in the button below",
  "undo": "Undo",
  "createContact": "Create contact",
  "noParties": "No parties",
  "exemptFrom1099": "Exempt from 1099",
  "foreignPerson": "Foreign person",
  "declinesToProvideSSN": "Declines to provide SSN",
  "party": "Party",
  "one-party": "1 party",
  "parties-count": "{{count}} parties",
  "groups": "Party groups",
  "sections": "Party sections",
  "all-parties": "All parties",
  "no-parties-yet": "No parties yet",
  "no-parties-label": "Use Add party to link the first party to this order.",
  "no-parties-group": "No parties in this group",
  "load-error": "We couldn’t load the parties for this order.",
  "contact-load-error": "We couldn’t load this contact’s information.",
  "party-not-found": "This party is no longer on this order",
  "party-not-found-label": "It may have been removed. Return to the party list to continue.",
  "remove-party-title": "Remove party from this order?",
  "remove-party-subtitle": "{{name}} will be removed as {{role}}. The contact itself won’t be deleted.",
  "remove-party-aria": "Remove {{name}} as {{role}}",
  "remove-association-title": "Remove association?",
  "remove-association-subtitle": "{{name}} will no longer be linked as {{linkedAs}} on this order.",
  "add-association": "Add association",
  "no-associations": "No linked parties on this order",
  "linked-as": "Linked as {{role}}",
  "change-kinds-aria": "Change roles for {{name}}",
  "reporting-options": "Reporting options",
  "collapse-all": "Collapse all",
  "expand-all": "Expand all",
  "collapse-role": "Collapse {{role}}",
  "expand-role": "Expand {{role}}",
  "scroll-tabs-left": "Scroll tabs left",
  "scroll-tabs-right": "Scroll tabs right",
  "filter-name-placeholder": "Filter by name, role or parent",
  "filter-name-label": "Filter parties",
  "no-filter-results": "No parties match your search"
}
